















import { getCategoriesDetail } from '@/service/common'
import { Component, Prop, Vue } from 'vue-property-decorator'
const columns = [
  {
    title: '一级类目',
    dataIndex: 'cname1',
    width: '18%',
  },
  {
    title: '二级类目',
    dataIndex: 'cname2',
    width: '18%',
  },
  {
    title: '三级类目',
    dataIndex: 'cname3',
    width: '18%',
  },
  {
    title: '联系人',
    dataIndex: 'contacts',
    width: '18%',
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    width: '28%',
  },
]
@Component({
  components: {},
})
export default class CategoriesDetail extends Vue {
  @Prop(Object) info!: any
  categoriesSubList = []
  loading = true
  columns = columns
  created() {
    this.getCategoriesDetail()
  }
  async getCategoriesDetail() {
    try {
      this.categoriesSubList = await getCategoriesDetail(this.info.id)
      this.loading = false
    } catch (err) {
      console.error(err)
    }
  }
}
